import React from "react"
import { Box, useRadio, useRadioGroup, HStack } from "@chakra-ui/react"
import { Tooltip } from "."

const  RadioCard = (props) => {

    const { getInputProps, getCheckboxProps } = useRadio(props)
    const input = getInputProps()
    const checkbox = getCheckboxProps()  

    const getColor = () => {
        switch(props?.value){
            case 'A':
                return 'red.500'       
            case 'P':
                return 'green.500'       
            case 'L':
                return 'blue.500'       
            case 'H':
                return 'orange.500'       
            default:
                return 'white'
        }
    }
    
    return (
        <Box as='label'>
            <input {...input} />
            <Tooltip label={props?.title} placement="top">
            <Box
                {...checkbox}
                cursor='pointer'
                borderWidth='1px'   
                fontSize="12px"     
                bg="white"       
                _checked={{
                    bg: getColor(),
                    color: 'white',
                    borderColor: getColor(),
                }}   
                _hover={{ 
                    borderColor: 'gray.300',
                 }}             
                px={2}
                py={0.5}
                >
                {props.children}
            </Box>
            </Tooltip>
        </Box>
    )
}

export const ToggleButtons = ({options, value, onChange, defaultValue, ...rest}) => {    
    
    const { getRootProps, getRadioProps } = useRadioGroup({
        name: 'framework',
        defaultValue: defaultValue,
        onChange: onChange,
        value: value,
    })

    const group = getRootProps()

    return (
        <HStack {...group} spacing={1}>
            {options.map((val) => {
                const radio = getRadioProps({ value: val?.value })
                return (
                    <RadioCard key={val?.value} title={val?.label} {...radio}>{val?.value}</RadioCard>
                )
            })}
        </HStack>
    )
}